import { render, staticRenderFns } from "./skeleton-list.vue?vue&type=template&id=22b942e4&scoped=true&"
import script from "./skeleton-list.vue?vue&type=script&lang=ts&"
export * from "./skeleton-list.vue?vue&type=script&lang=ts&"
import style0 from "./skeleton-list.vue?vue&type=style&index=0&id=22b942e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b942e4",
  null
  
)

export default component.exports